import { render, staticRenderFns } from "./Authenticated.vue?vue&type=template&id=f95f34e4&"
import script from "./Authenticated.vue?vue&type=script&setup=true&lang=js&"
export * from "./Authenticated.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports